import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMsal } from "@azure/msal-react";
import {
    MotifAvatar,
    MotifHeader,
    MotifHeaderLogo,
    MotifIcon,
    MotifMenu,
    MotifButton,
    MotifMenuItem,
    MotifMenuItemGroup,
    MotifDropdownPortal,
    MotifDropdownItem,
    MotifVerticalNavigationHeaderButton as MotifVerticalNavHeaderButton,
} from '@ey-xd/motif-react';
import { actionIcExitToApp24px, socialIcLocationCity24px } from '@ey-xd/motif-react/assets/icons';
import { setSideBarCollapsed } from '../../redux/actions/SideBar/sideBar'
import EYLogo from '../../assets/media/images/ey-logo.png'
import './Header.scss'
import { MotifSelect } from '@ey-xd/motif-react';
import { MotifOption } from '@ey-xd/motif-react';
import { MotifPeopleTemplate } from '@ey-xd/motif-react';
import { getTenantDetails, setCurrentTenant } from '../../redux/actions/User/user';

const Header = () => {

  const [userDetailMenu, setUserDetailMenu] = useState<boolean>(false);
  const sideCollapsed = useSelector((state: any) => state?.sideBar?.collapsed) || false;
  const tenant = JSON.parse(sessionStorage.getItem('tenant') || '{}');
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const userName = sessionStorage.getItem('user');
  const [selectedTenant, setSelectedTenant] = useState(tenant || {});
  const tenants = useSelector((state: any) => state?.user?.tenants) || [];

  useEffect(() => {
    if(tenants.length <= 0) {
      // Identity is derived from the JWT server-side; no user_email argument.
      const p: any = dispatch(getTenantDetails());
      if (p && typeof p.catch === 'function') {
        p.catch((err: any) => {
          const status = err?.response?.status;
          const code = err?.response?.data?.error || err?.response?.data?.detail;
          if (status === 401) {
            console.warn('[Auth] /user/tenants returned 401 authentication_required. Redirecting to login.');
            try { sessionStorage.removeItem('idToken'); } catch {}
            instance.logoutRedirect();
          } else if (status === 403 && code === 'identity_mismatch') {
            console.error('[Auth] /user/tenants returned 403 identity_mismatch. Local user context is out of sync with the JWT. Forcing re-login.');
            try { sessionStorage.removeItem('idToken'); } catch {}
            instance.logoutRedirect();
          }
        });
      }
    }
  }, []);

  // When tenants are loaded, ensure selectedTenant is populated from storage or defaults
  useEffect(() => {
    if (tenants.length > 0) {
      let persisted: any = null;
      try {
        const raw = sessionStorage.getItem('tenant');
        persisted = raw ? JSON.parse(raw) : null;
      } catch {}
      const match = persisted
        ? (tenants.find((t: any) => t.TenantId === persisted.TenantId) || tenants.find((t: any) => t.TenantName === persisted.TenantName))
        : null;
      const nextTenant = match || tenants[0];
      setSelectedTenant(nextTenant);
      try { sessionStorage.setItem('tenant', JSON.stringify(nextTenant)); } catch {}
    }
  }, [tenants]);

  const handleSignOut = () => {
    instance.logoutRedirect();
  }
  
  const handleSelect = (e: any) => {
    sessionStorage.setItem('tenant', JSON.stringify(e));
    setSelectedTenant(e);
    dispatch(setCurrentTenant(e));
  }

  useEffect(() => {
    if (tenant && tenant.TenantId) {
      dispatch(setCurrentTenant(tenant));
    }
  }, []);

  return (
    <div className="headerWrapper">
      <MotifHeader
        appHeaderName="ASC Cloud - AuPen AI"
        logo={
          <MotifHeaderLogo>
            <div>
              <img src={EYLogo} alt='EY Logo - Home' width={28} className="eyLogo"/>
            </div>
          </MotifHeaderLogo>
        }
        leftComponents={
          <MotifVerticalNavHeaderButton class="test" onClick={() => dispatch(setSideBarCollapsed(!sideCollapsed))} />
        }
        iconsContainer={
          <div className="header__icons">
            <img
              src={selectedTenant?.LogoUrl || EYLogo}
              alt={(selectedTenant?.TenantName || 'Tenant') + ' logo'}
              width={24}
              height={24}
              className="header__tenantLogo"
            />
            <MotifSelect
              ariaLabelledBy="select-label-people"
              value={selectedTenant}
              className="header__tenantSelect"
              onChange={handleSelect}
            >
              {tenants.map((tenant: any, index: number) => (
                <MotifOption
                  className="header__tenantOption"
                  label={tenant.TenantName}
                  value={tenant}
                  key={tenant.TenantId}
                >
                  <MotifPeopleTemplate
                      item={{
                        disabled: false,
                        id: index,
                        image: tenant.LogoUrl || EYLogo,
                        name: tenant.TenantName,
                      }}
                  />
                </MotifOption>
              ))}
            </MotifSelect>
            <MotifDropdownPortal
              open={userDetailMenu}
              hideArrow={false}
              trigger={
                  <MotifButton
                      aria-label="Profile dropdown menu"
                      aria-describedby="Profile dropdown menu"
                      type="button"
                      className="header__avatar"
                      onClick={() => setUserDetailMenu(!userDetailMenu)}
                  >
                      <MotifAvatar
                          userName={userName}
                          email={"Test Email"}
                          status={'online'}
                      />
                  </MotifButton>
              }>
              <MotifDropdownItem className="header__item" onClick={() => {}}>
                  <MotifAvatar
                      userName={userName}
                      email={"Test Email"}
                      status={'online'}
                  />
                  <div className="header__info">
                    <div className="header__displayname">{userName}</div>
                  </div>
              </MotifDropdownItem>
              <MotifDropdownItem className="header__item" onClick={()=>{}}>
                  <span className="header__item__role">Role:</span>
                  <span>Admin</span>
              </MotifDropdownItem>
              <MotifDropdownItem className="header__item" onClick={handleSignOut}>
                  <MotifIcon src={actionIcExitToApp24px} />
                  <span>Log out</span>
              </MotifDropdownItem>
          </MotifDropdownPortal>
        </div>
        }
      />
    </div>
  )
}

export default Header
